module.exports = __webpack_public_path__ + "img/Hotmart-3-pt.fd22a820.png";